<template>
  <div class="skeleton-loader-item" :class="`skeleton-loader-${type}`"></div>
</template>

<script>
export default {
  name: "SkeletonLoader",

  props: {
    type: {
      type: String,
      default: "default",
    },
  },
};
</script>

<style lang="postcss" scoped>
.skeleton-loader-item {
  width: 100%;
  height: 64px;
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.5s infinite linear;
}

.skeleton-loader-image {
  width: 4rem;
  height: 4rem;
}

.skeleton-loader-name,
.skeleton-loader-numberAndDate {
  height: 34px;
}

.skeleton-loader-name {
  @media (max-width: 768px) {
    height: 64px;
  }
}

.skeleton-loader-buttons,
.skeleton-loader-region,
.skeleton-loader-status {
  height: 24px;
  @media (max-width: 768px) {
    width: 50%;
  }
}

.skeleton-loader-checkbox {
  height: 24px;
  width: 24px;
}

.skeleton-loader-order {
  height: 19px;
}

.skeleton-loader-id,
.skeleton-loader-accessGroup,
.skeleton-loader-companies,
.skeleton-loader-dealers,
.skeleton-loader-bonusProgramLevel,
.skeleton-loader-priceDealer,
.skeleton-loader-priceBasic,
.skeleton-loader-priceBasicCash,
.skeleton-loader-priceDealerCash,
.skeleton-loader-priceBasicCashless,
.skeleton-loader-priceDealerCashless,
.skeleton-loader-priceGeneral,
.skeleton-loader-availability,
.skeleton-loader-quantity,
.skeleton-loader-price,
.skeleton-loader-sum,
.skeleton-loader-company,
.skeleton-loader-contract,
.skeleton-loader-hasPaidStorageAgreement,
.skeleton-loader-storage,
.skeleton-loader-deliveryType,
.skeleton-loader-taxNumber,
.skeleton-loader-user,
.skeleton-loader-customer,
.skeleton-loader-publishedAt,
.skeleton-loader-documentDate {
  height: 16px;
}

@keyframes shimmer {
  0% {
    background-position: 100%;
  }
  100% {
    background-position: -100%;
  }
}
</style>
